var _defs, _g, _g2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClearFullLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1278.86 337.61",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#041a55;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 14.02,
    cy: 168.48,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 77.1,
    cy: 168.48,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.26,
    cy: 209.84,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 96.63,
    cy: 227.8,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 99.41,
    cy: 276.77,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 51.26,
    cy: 127.08,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.54,
    cy: 72.75,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 96.63,
    cy: 108.74,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 98.44,
    cy: 61.68,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 145.93,
    cy: 72.75,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.05,
    cy: 72.75,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 253.34,
    cy: 61.08,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.52,
    cy: 109.7,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 301.9,
    cy: 127.08,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 301.9,
    cy: 209.84,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 256.52,
    cy: 227.94,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 308.14,
    cy: 264.21,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 207.05,
    cy: 264.21,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 145.93,
    cy: 264.21,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 45.13,
    cy: 264.21,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 253.34,
    cy: 276.77,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 176.31,
    cy: 301.49,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 226.67,
    cy: 323.6,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 126.59,
    cy: 323.6,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 276.47,
    cy: 168.48,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 339.2,
    cy: 168.48,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 308.13,
    cy: 72.75,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 176.31,
    cy: 35.49,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 126.2,
    cy: 14.02,
    r: 14.02
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 226.81,
    cy: 14.02,
    r: 14.02
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M491.73,168.81c0-40.05,30.48-70.46,70.37-70.46,24.93-.24,48.12,12.73,60.97,34.09l-23.32,14.67c-6.98-14.25-21.6-23.16-37.47-22.82-25.2,0-43.65,19.71-43.65,44.53-.02,24.23,18.28,44.26,43.3,44.26,16.95,.32,32.38-9.73,38.95-25.35l24.26,12.97c-11.82,23.93-36.34,38.94-63.03,38.59-41.41,0-70.37-31.56-70.37-70.46"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "674.32 100.25 674.32 237.43 764.45 237.43 764.45 211.7 701.04 211.7 701.04 100.25 674.32 100.25"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "816.64 100.25 816.64 237.43 909.05 237.43 909.05 212.26 843.18 212.26 843.18 181.06 896.81 181.06 896.81 156.06 843.18 156.06 843.18 125.24 909.05 125.24 909.05 100.25 816.64 100.25"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1009.75,100.25l-51.92,137.19h27.26l8.96-24.97h57.38l8.96,24.97h27.28l-51.92-137.19h-26.01Zm13.17,33.6l19.75,54.58h-39.69l19.93-54.58Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1163.96,124.68v45.29h27.1c17.49,0,25.6-10.91,25.6-23.12,0-13.44-8.67-22.17-25.6-22.17h-27.1Zm-26.52-24.44h55.7c31.61,0,50.42,20.29,50.42,46.43,.37,17.01-8.97,32.75-24.08,40.58l27.1,50.17h-29.75l-22.02-43.23h-30.86v43.23h-26.52V100.25Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1266.86,100.19c1.66,0,3.23,.32,4.69,.96,1.46,.64,2.74,1.52,3.82,2.62,1.08,1.11,1.94,2.41,2.56,3.9s.93,3.08,.93,4.77-.31,3.27-.95,4.74c-.63,1.47-1.49,2.77-2.57,3.89-1.09,1.12-2.35,1.99-3.81,2.64-1.45,.64-3.01,.96-4.68,.96s-3.29-.32-4.77-.96c-1.47-.64-2.76-1.52-3.85-2.64-1.09-1.12-1.95-2.41-2.57-3.89-.62-1.47-.93-3.05-.93-4.74s.31-3.27,.93-4.77,1.48-2.79,2.57-3.9c1.09-1.1,2.38-1.98,3.85-2.62,1.47-.64,3.06-.96,4.77-.96Zm0,21.73c1.26,0,2.45-.25,3.55-.74,1.11-.49,2.07-1.17,2.89-2.04,.82-.86,1.47-1.87,1.94-3.02,.47-1.15,.71-2.37,.71-3.68s-.24-2.57-.71-3.73c-.47-1.16-1.12-2.16-1.94-3.02-.82-.85-1.78-1.53-2.89-2.02-1.1-.49-2.29-.74-3.55-.74s-2.48,.25-3.6,.74c-1.12,.5-2.09,1.17-2.92,2.02-.83,.85-1.48,1.86-1.96,3.02-.47,1.16-.71,2.4-.71,3.73s.24,2.53,.71,3.68c.47,1.15,1.13,2.15,1.96,3.02,.83,.86,1.8,1.54,2.92,2.04,1.12,.5,2.32,.74,3.6,.74Zm.69-15.25c1.41,0,2.5,.32,3.25,.98,.76,.65,1.14,1.55,1.14,2.68,0,.95-.3,1.72-.91,2.32s-1.47,.97-2.59,1.12l3.57,4.33h-2.81l-3.32-4.3h-1.04v4.3h-2.37v-11.43h5.08Zm-2.72,2.15v3.03h2.65c.63,0,1.13-.13,1.5-.38s.55-.63,.55-1.14-.19-.88-.55-1.14-.87-.38-1.5-.38h-2.65Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClearFullLogo);
export default __webpack_public_path__ + "static/media/clear_full_logo.dba6082c3d03787f8d5eeb8b3ac77bfd.svg";
export { ForwardRef as ReactComponent };